import type { ResourceFilterOption } from '@/shared/ui/Layout'

import { resolveItemRewardCategory } from './resolveItemRewardCategory'
import type { StoreCatalogItem } from './types'

export const deriveStoreCategoryOptions = (
  items: StoreCatalogItem[]
): ResourceFilterOption<string>[] => {
  const byId = new Map<string, string>()

  items.forEach(item => {
    const category = resolveItemRewardCategory(item)
    if (!category) return

    byId.set(category.id, category.name)
  })

  return Array.from(byId.entries())
    .map(([id, label]) => ({ id, label }))
    .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'))
}
